var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.741,
    height: 18.098,
    viewBox: "0 0 23.741 18.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 -8.371)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 8.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.539,16.352l-3.85-3.85V9.989a.693.693,0,0,0-1.387,0v1.128L15.76,8.574a.692.692,0,0,0-.98,0l-3.05,3.05-1.218-1.217a.693.693,0,0,0-.98,0L.2,19.736a.693.693,0,0,0,.98.98l8.84-8.84,8.84,8.84a.693.693,0,0,0,.98-.98l-4.658-4.657V12.007a.693.693,0,1,0-1.387,0v1.686L12.71,12.6l2.561-2.56,7.289,7.288a.693.693,0,0,0,.98-.98Z",
    transform: "translate(-0.001 -8.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.722,29.6l-7.347-7.348a.693.693,0,0,0-.98,0L6.047,29.6a.688.688,0,0,0-.19.358,1.667,1.667,0,0,0-.031.318v3.586A1.677,1.677,0,0,0,7.5,35.534h3.586a1.678,1.678,0,0,0,1.675-1.675V31.226a1.242,1.242,0,0,1,1.123-1.233,1.242,1.242,0,0,1,1.123,1.233v2.633a1.677,1.677,0,0,0,1.675,1.675h3.587a1.677,1.677,0,0,0,1.675-1.675V30.273a1.613,1.613,0,0,0-.031-.318A.7.7,0,0,0,21.722,29.6Z",
    transform: "translate(-3.862 -17.436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouses);
export default __webpack_public_path__ + "static/media/houses.874928bb5cc1b4581b74b725ec86f661.svg";
export { ForwardRef as ReactComponent };